<template>
    <transition name="fade">
        <div class="preloader">
            <div class="img">
                <svg class="filter" version="1.1">
                    <defs>
                        <filter id="gooeyness">
                            <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
                            <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 20 -10" result="gooeyness" />
                            <feComposite in="SourceGraphic" in2="gooeyness" operator="atop" />
                        </filter>
                    </defs>
                </svg>
                <div class="dots">
                    <div class="dot mainDot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                </div>
            </div>
        </div>
    </transition>

</template>

<script>
    export default {
        name: "Preloader",
    }
</script>
